var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { renderToStaticMarkup } from "react-dom/server";
/** The sidebar toolbar's blue. */
export var blueToolbarIconColors = {
    disc: "#3572C6",
    ring: "#2F80ED",
    symbol: "white",
};
/** The same icon in grey, for a toolbar button that is disabled. */
export var greyToolbarIconColors = {
    disc: "#9A9A9A",
    ring: "#8C8C8C",
    symbol: "white",
};
/** The placeholder icons in the scene, for a node that has no component
 * picked yet. They are drawn without the scene's tone mapping
 * (`icon-billboard`), so these are the colours on screen. */
export var placeholderIconColors = {
    disc: "#D9D9D9",
    ring: "#CFCFCF",
    symbol: "#F7F7F7",
};
/** The placeholder icons while hovered or highlighted: a dark grey disc and
 * ring, barely tinted blue, so they light up without reading as the
 * toolbar's blue. The symbol keeps its colour. */
export var hoveredPlaceholderIconColors = __assign(__assign({}, placeholderIconColors), { disc: "#3E4550", ring: "#5D6673" });
export var VacuumPumpIcon = function (_a) {
    var size = _a.size, _b = _a.colors, colors = _b === void 0 ? blueToolbarIconColors : _b;
    return (_jsxs("svg", { width: size, height: size, viewBox: "0 0 43 43", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("circle", { cx: "21.0827", cy: "21.0827", r: "21.0827", fill: colors.disc, fillOpacity: "0.65" }), _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.0827 39.7981C31.4189 39.7981 39.7981 31.4189 39.7981 21.0827C39.7981 10.7465 31.4189 2.36733 21.0827 2.36733C10.7465 2.36733 2.36733 10.7465 2.36733 21.0827C2.36733 31.4189 10.7465 39.7981 21.0827 39.7981ZM21.0827 42.1654C32.7263 42.1654 42.1654 32.7263 42.1654 21.0827C42.1654 9.43904 32.7263 0 21.0827 0C9.43904 0 0 9.43904 0 21.0827C0 32.7263 9.43904 42.1654 21.0827 42.1654Z", fill: colors.ring }), _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.3929 23.8427C29.0847 24.1508 29.0847 24.6505 29.3929 24.9586C29.701 25.2668 30.2007 25.2668 30.5088 24.9586L33.5099 21.9576C33.8181 21.6494 33.8181 21.1497 33.5099 20.8416L30.5088 17.8405C30.2007 17.5323 29.701 17.5323 29.3929 17.8405C29.0847 18.1487 29.0847 18.6483 29.3929 18.9565L30.946 20.5097L9.07524 20.5097C8.63943 20.5097 8.28613 20.863 8.28613 21.2988C8.28613 21.7346 8.63943 22.0879 9.07524 22.0879L31.0986 22.0879C31.1156 22.0879 31.1325 22.0873 31.1492 22.0863L29.3929 23.8427Z", fill: colors.symbol }), _jsx("path", { d: "M29.4128 13.4068C29.4128 13.4068 27.1531 15.3438 21.0196 15.3438C14.886 15.3438 12.6263 13.4068 12.6263 13.4068", stroke: colors.symbol, strokeWidth: "1.57822", strokeLinecap: "round" }), _jsx("path", { d: "M12.6257 29.1947C12.6257 29.1947 14.8855 27.2578 21.019 27.2578C27.1526 27.2578 29.4123 29.1947 29.4123 29.1947", stroke: colors.symbol, strokeWidth: "1.57822", strokeLinecap: "round" })] }));
};
/** An SVG element rendered to a data URL, so it can be drawn outside React. */
export var svgDataUrl = function (svg) {
    return "data:image/svg+xml;charset=utf-8,".concat(encodeURIComponent(renderToStaticMarkup(svg)));
};
/**
 * The icon as an SVG data URL, so it can be drawn outside React — as a
 * PlayCanvas texture, say. `size` is the raster size browsers decode it at.
 */
export var vacuumPumpIconDataUrl = function (size, colors) { return svgDataUrl(_jsx(VacuumPumpIcon, { size: size, colors: colors })); };
